// ----------------------------------------------------------------------
// <copyright file="Izenda.UserSetUpDetailAction.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var compose = require('recompose').compose;
  var ValidationCategoriesPopup = require('../../Izenda.ValidationCategoriesPopup');
  var constants = require('logic/data/Izenda.UserAccountConstants');
  var connect = require('share/enhancers/Izenda.Connect');
  var withHandlers = require('recompose').withHandlers;
  var localizer = require('share/localization/Izenda.Localizer');
  const { curry, isNil, isBoolean, isEmpty } = require('lodash/fp');

  var userSetUpDetailAction = compose(
    connect(),
    withHandlers({
      onSave: curry(onSave),
      onCancel: curry(onCancel)
    })
  );

  /**
   * save user set up detail
   */
  function onSave(props, obj) {
    var valManager = props.validation;
    var loader = props.loader;
    var validateFields = ['UserName', 'firstName', 'lastName', 'roles', 'emailAddress', 'DataOffset', 'TimestampOffset'];
    var configUser = props.store.configUserCloned;

    valManager.validate(validateFields).then(function(success) {
      configUser.updateFormHasErrors(!success);
      if (success) {
        loader.startLoading();
        props.store
          .validateUserRoleAssociation()
          .then(function(result) {
            if (isBoolean(result) && result) {
              // promise return true then execute Save
              return handleSave(props);
            } else {
              const association = constants.VALIDATE_RESULT_ROLE_ASSOCIATION_KEYS[result.messages[0].key];
              const messageHeader = String.format(
                localizer.getText('USER_SETUP_ERROR_ROLE_ASSOCIATION_MESSAGE_HEADER'),
                association.type,
                association.permission
              );
              return props.openPopup(ValidationCategoriesPopup, {
                header: messageHeader,
                data: result.messages[0].detail,
                footer: localizer.getText('USER_SETUP_ERROR_ROLE_ASSOCIATION_MESSAGE_FOOTER')
              });
            }
          })
          .finally(loader.endLoading.bind(loader));
      }
    });
  }

  /**
   * handle Save
   * @param  {object} props
   */
  function handleSave(props, obj) {
    var loader = props.loader;
    var store = props.store;
    var localization = props.localization;

    var valManager = props.validation;
    loader.startLoading();
    return store
      .save()
      .then(function(result) {
        if (!isNil(result.messages)) {
          isEmpty(result.messages[0].key)
            ? (store.alertMessage = {
                type: 'info',
                message: result.messages[0].messages[0]
              })
            : valManager.updateErrors(result.messages);
        }
        result.hasChangeLanguage && props.confirmMessage('info', localization.getText('USER_MESSAGE_CHANGE_LANGUAGE'));
        return null;
      })
      .finally(loader.endLoading.bind(loader));
  }

  /**
   * cancel modification and reload
   */
  function onCancel(props, obj) {
    var loader = props.loader;
    props.validation.reset();
    props.store.cloneUserSetupDetail();
  }

  module.exports = userSetUpDetailAction;
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/UserSetup/UserSetupDetail/Izenda.UserSetUpDetailAction.js